import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './App.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import WrapWithProvider from './components/wrap-with-provider';
import { Router } from 'react-router-dom';
import { globalHistory } from './history';

ReactDOM.render(
  <React.StrictMode>
    <Router history={globalHistory}>
      <WrapWithProvider>
        <App />
      </WrapWithProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
